import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { isNotDefined } from '@hsp/utilities';

import { audienceService } from 'services';
import { defaultAggregate, defaultAggregateMultiRfm, IAudienceSearchApi, IMultiRfmSearch } from 'types/api/audience';
import { IAudienceBuilderAggregateState } from 'types/store/audience-builder';

const initialState: IAudienceBuilderAggregateState = {
  applied: false,
  data: defaultAggregate,
  loading: false,
};

export const getAggregate = createAsyncThunk('ab/getAggregate', async (searchParameters: IAudienceSearchApi) => {
  const result = await audienceService.getAggregate(searchParameters);

  if (isNotDefined(result)) {
    return defaultAggregate;
  }

  return result.dataContainer;
});

export const getAggregateMultiRfm = createAsyncThunk(
  'ab/getAggregateMultiRfm',
  async (searchParameters: IMultiRfmSearch) => {
    const result = await audienceService.getAggregateMultiRfm(searchParameters);

    if (isNotDefined(result)) {
      return defaultAggregateMultiRfm;
    }

    return result.dataContainer;
  }
);

export const aggregateSlice = createSlice({
  extraReducers: (builder) => {
    builder.addCase(getAggregate.fulfilled, (state, { payload: data }) => {
      state.loading = false;

      if (isNotDefined(data)) {
        state.error = 'Unknown error occurred';

        return;
      }

      state.applied = true;
      state.data = data;

      delete state.error;
    });
    builder.addCase(getAggregate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAggregate.rejected, (state, { error }) => {
      state.applied = false;
      state.error = error;
      state.loading = false;
    });
    builder.addCase(getAggregateMultiRfm.fulfilled, (state, { payload: data }) => {
      state.loading = false;

      if (isNotDefined(data)) {
        state.error = 'Unknown error occurred';

        return;
      }

      state.applied = true;
      state.data = data;

      delete state.error;
    });
    builder.addCase(getAggregateMultiRfm.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAggregateMultiRfm.rejected, (state, { error }) => {
      state.applied = false;
      state.error = error;
      state.loading = false;
    });
  },
  initialState,
  name: 'ab/aggregate',
  reducers: {
    clearAggregate: (state) => {
      state.applied = false;
      state.data = defaultAggregate;
      state.loading = false;

      delete state.error;
    },
    setAggregateApplied: (state, { payload }: PayloadAction<boolean>) => {
      state.applied = payload;
    },
  },
});

export const aggregateReducer = aggregateSlice.reducer;
